import React, { useState, useEffect } from 'react';
import { Button, Box, Avatar, ButtonBase } from '@mui/material';
import { CloudUpload } from '@mui/icons-material';
import { apiBaseUrl } from '../utils/Api/Api';
import Pets from '@mui/icons-material/Pets';

/* Icons */
import EditIcon from '@mui/icons-material/Edit';

const AvatarUploader = ({ pet, handleAvatarChange }) => {

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (e) => {
      handleAvatarChange(e.target.result);
    };
    reader.readAsDataURL(file);
  };

  return (
    <Box sx={{ display: 'inline-block', position: 'relative' }}>
      <Avatar
        src={pet.avatar_url ? `${apiBaseUrl}${pet.avatar_url}` : undefined}
        alt={pet.name}
        sx={{ width: 120, height: 120 }}
      >
        <Pets/>
      </Avatar>
      <ButtonBase
        variant="outlined"
        component="label"
        //startIcon={<CloudUpload />}
        sx={{
          width: '32px', height: '32px', borderRadius: '50%', bgcolor: '#263238', color: 'white',
          display: 'flex', position: 'absolute', bottom: 0, right: 1, p: 1}}>
        <EditIcon sx={{ width: '16px', height: '16px' }} /> {/* 12px fica muito pequeno */}
        <input type="file" hidden onChange={handleImageChange} />
      </ButtonBase>
    </Box>
  );
};

export default AvatarUploader;

